import { render, staticRenderFns } from "./ToolBarIcon.vue?vue&type=template&id=45b71a6a&scoped=true"
import script from "./ToolBarIcon.vue?vue&type=script&lang=js"
export * from "./ToolBarIcon.vue?vue&type=script&lang=js"
import style0 from "./ToolBarIcon.vue?vue&type=style&index=0&id=45b71a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b71a6a",
  null
  
)

export default component.exports